import Swiper, { Autoplay, Navigation } from 'swiper'
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/navigation'

export class CourseFeatureSlider {
  constructor() {
    if (document.querySelector('.js-course_feature_slider') === null) return
    let options = {}
    const slider = document.querySelectorAll('.js-course_feature_slider')
    for (let index = 0; index < slider.length; index++) {
      let slideList = slider[index].querySelectorAll('.swiper-slide')
      if (slideList.length > 1) {
        options = {
          modules: [Autoplay, Navigation],
          loop: true,
          slidesPerView: 1.2,
          spaceBetween: 20,
          speed: 600,
          centeredSlides: true,
          navigation: {
            nextEl: '.js-course_feature_arrow_next',
            prevEl: '.js-course_feature_arrow_prev',
          },
          autoplay: {
            delay: 7000,
          },
          breakpoints: {
            767: {
              slidesPerView: 1.74,
              spaceBetween: 50,
            },
          },
        }
      } else {
        options = {
          loop: false,
          slidesPerView: 1.2,
          spaceBetween: 20,
          speed: 600,
          centeredSlides: true,
          breakpoints: {
            767: {
              slidesPerView: 1.74,
              spaceBetween: 50,
            },
          },
        }
      }
    }

    new Swiper('.js-course_feature_slider', options)
  }
}
